/** Moving between pages without reloading (main.ts sets what drawing a page means). */
let renderer: () => void = () => {};

export function setRenderer(f: () => void): void {
  renderer = f;
}

export function navigateTo(path: string): void {
  if (location.pathname + location.search + location.hash !== path) history.pushState(null, '', path);
  renderer();
}
